import { render } from "./HeaderChatbotsComponent.vue?vue&type=template&id=37509ac9&scoped=true"
import script from "./HeaderChatbotsComponent.vue?vue&type=script&lang=js"
export * from "./HeaderChatbotsComponent.vue?vue&type=script&lang=js"

import "./HeaderChatbotsComponent.vue?vue&type=style&index=0&id=37509ac9&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37509ac9"]])

export default __exports__